import React from 'react';
import ButtonV3 from '@zola/zola-ui/src/components/ButtonV3/ButtonV3';
import { trackCtaClicked, CTA_TYPES } from '@zola-helpers/client/dist/es';
import { mangeWebsiteCreateTrackingPayload } from 'components/manage/ManageWebsite/components/utils';
import { SingleSampleAccessPointUIProps } from '../../../util/types';

const APMangeWebsitePage: React.FC<SingleSampleAccessPointUIProps> = ({ handleOpenModal }) => {
  const handleClickBtn = () => {
    if (handleOpenModal) {
      trackCtaClicked(
        mangeWebsiteCreateTrackingPayload({
          group_id: 'WEBSITE_CAROUSEL',
          cta: 'Sample Save the Dates',
          cta_id: 'matching-stds-carousel',
          cta_type: CTA_TYPES.BUTTON,
          position: 0,
        })
      );
      handleOpenModal({ entryPoint: 'WEBSITE_MANAGE_PAGE' });
    }
  };
  return (
    <ButtonV3 component="button" variant="primary" onClick={handleClickBtn}>
      Sample Save the Dates
    </ButtonV3>
  );
};

export default APMangeWebsitePage;
